<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" class="mb-3" />
        <v-card color="white" dark v-if="loaddata">
          <v-card-text class="primary--text">
            กรุณารอซักครู่...
            <v-progress-linear
              indeterminate
              color="primary"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
        <v-card
          v-else
          class="pa-3"
          :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
        >
          <v-col cols="12" class="pa-0 mt-2">
            <v-row>
              <v-col cols="auto">
                <v-menu
                  v-model="startDatePicker"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDateText"
                      label="วันที่เริ่มต้น"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="startDatePicker = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="startDate"
                    locale="th"
                    @input="startDatePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="auto">
                <v-menu
                  v-model="endDatePicker"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDateText"
                      label="วันที่สิ้นสุด"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="endDatePicker = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="endDate"
                    locale="th"
                    :min="startDate"
                    @input="endDatePicker = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="auto">
                <v-btn
                  color="primary"
                  depressed
                  @click="onSearch(startDate, endDate)"
                >
                  <v-icon>
                    mdi-magnify
                  </v-icon>
                  ค้นหา
                </v-btn>
              </v-col>

              <v-col cols="auto">
                <v-btn
                  color="primary"
                  outlined
                  depressed
                  @click="onSearch(0, 0)"
                >
                  ทั้งหมด
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row justify="end">
              <v-btn
                color="success"
                @click="btnSearchAccessroles"
                class="float-right"
              >
                <v-icon>mdi-plus</v-icon> เพิ่มข้อมูล</v-btn
              >
            </v-row>
          </v-col>

          <v-col cols="12" class="pa-0 ma-0">
            <history-table
              :headers="headers"
              :items="leaveList"
              :loading="loading"
              @delBtn="onSaveConDelDialog"
              @detailBtn="detailDialog"
              @editBtn="btnEditDetail"
            />
          </v-col>
        </v-card>
      </v-container>
    </v-main>
    <v-dialog v-model="dialogAddMenu" max-width="900px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text">เพิ่มข้อมูล</v-card-title>
        <v-form ref="formDialogAdd" v-model="isFormValidDialogAdd">
          <v-card-text>
            <v-divider class="mb-4"></v-divider>
            <v-row justify="center">
              <v-col cols="12" sm="5">
                <v-menu
                  v-model="startDatePickerDialog"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDateTextDialog"
                      label="วันที่เริ่มต้น"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="startDatePickerDialog = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="startDateDialog"
                    locale="th"
                    @input="startDatePickerDialog = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="5">
                <v-menu
                  v-model="endDatePickerDialog"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDateTextDialog"
                      label="วันที่สิ้นสุด"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="endDatePickerDialog = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="endDateDialog"
                    locale="th"
                    :min="startDateDialog"
                    @input="endDatePickerDialog = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <!-- <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-autocomplete
                  v-model="form.trainningactiontype"
                  :items="trainningactiontypesList"
                  item-text="trainingAtionTypeName"
                  item-value="trainingActionTypeId"
                  hide-details="auto"
                  label="ระบบ"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row> -->
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.projectName"
                  outlined
                  name="input-7-4"
                  label="ชื่อหัวข้ออบรม"
                  dense
                  hide-details="auto"
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.instituteName"
                  outlined
                  name="input-7-4"
                  label="สถานที่อบรม"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.instituteAddress"
                  outlined
                  name="input-7-4"
                  label="ที่อยู่ที่อบรม"
                  hide-details="auto"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-textarea
                  v-model="form.description"
                  outlined
                  name="input-7-4"
                  label="รายละเอียด"
                  hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-autocomplete
                  v-model="form.countryID"
                  :items="countrysDataList"
                  item-text="countryNameTha"
                  item-value="countryID"
                  hide-details="auto"
                  label="ประเทศ"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-combobox
                  v-model="trainKeywordSelect"
                  :items="trainKeywordSelectItems"
                  :search-input.sync="trainKeywordTyp"
                  hide-selected
                  clearable
                  label="คีย์เวิร์ด"
                  multiple
                  persistent-hint
                  small-chips
                  outlined
                  dense
                  hide-details="auto"
                  deletable-chips
                  :rules="[rules.inputblank]"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-chip
                            v-if="trainKeywordTyp"
                            @click="addTrainKeyword"
                            color="black"
                            label
                            outlined
                            >{{ trainKeywordTyp }}
                            <v-icon small class="ml-1" @click="closechip">
                              mdi-close-circle
                            </v-icon>
                          </v-chip>

                          <span class="grey--text">
                            กด Enter หรือ คลิ๊ก เพื่อเพิ่ม</span
                          >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <!-- <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.capitalReserveName"
                  outlined
                  name="input-7-4"
                  label="ชื่อทุน"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <v-row justify="center">
              <v-col cols="12" sm="10" class="mt-n5">
                <v-radio-group v-model="rCer" dense hide-details="auto" row>
                  <v-radio label="ไม่มีประกาศนียบัตร" value="2"></v-radio>
                  <v-radio label="มีประกาศนียบัตร" value="1"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row justify="center" v-if="rCer === '1'">
              <v-col cols="12" sm="10" class="mt-n5">
                <v-text-field
                  v-model="form.certificateName"
                  outlined
                  name="input-7-4"
                  label="ชื่อประกาศนียบัตร"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.workHour"
                  outlined
                  name="input-7-4"
                  label="จำนวนชั่วโมงทำงาน"
                  hide-details="auto"
                  dense
                  type="number"
                  :rules="[rules.onlyDigit]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10" class="mt-n6">
                <v-radio-group
                  v-model="form.hourType"
                  dense
                  hide-details="auto"
                  row
                >
                  <v-radio label="ชั่วโมงจริง" value="1"></v-radio>
                  <v-radio label="ชั่วโมง/สัปดาห์" value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-n9">
            <v-col cols="12" sm="11">
              <v-btn
                color="primary  "
                class="float-right"
                @click="dialogAddMenuCon()"
                >บันทึก</v-btn
              >
              <v-btn
                class="white--text mr-2 float-right "
                color="grey lighten-1"
                outlined
                @click="dialogAddMenu = false"
                >ปิด
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOnSave" max-width="500px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text"
          >ยืนยันการบันทึก</v-card-title
        >
        <v-card-text>
          <v-divider class="mb-4"></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-4 mt-n8">
            <v-btn
              class="white--text mr-2"
              color="error "
              outlined
              @click="dialogOnSave = false"
              >ยกเลิก
            </v-btn>
            <v-btn class="white--text " color=" success" @click="onSaveCon()"
              >ยืนยัน
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOnDel" max-width="500px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text">ยืนยันการลบ?</v-card-title>
        <v-card-text>
          <v-divider class="mb-4"></v-divider>
          <!-- <v-row><v-col cols="4"></v-col><v-col cols="8"></v-col></v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-4 mt-n8">
            <v-btn
              class="white--text mr-2"
              color="error "
              outlined
              @click="dialogOnDel = false"
              >ยกเลิก
            </v-btn>
            <v-btn class="white--text " color=" success" @click="onSaveConDel()"
              >ยืนยัน
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOnDetail" max-width="800px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text">รายละเอียด</v-card-title>
        <v-card-text class="text-body-1 ">
          <v-divider class="mb-4"></v-divider>
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>หัวข้อ:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.projectName }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>สถานที่อบรม:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.instituteName }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>ที่อยู่ที่อบรม:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.instituteAddress }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>วันที่เริ่มต้น:</span></v-col
            ><v-col cols="8" sm="4"
              ><span>{{
                $dateFormatByLang(dataTrainingDetail.beginDate)
              }}</span></v-col
            >
            <v-col cols="4" sm="2" class="black--text"
              ><span>วันที่สิ้นสุด:</span></v-col
            ><v-col cols="8" sm="4"
              ><span>{{
                $dateFormatByLang(dataTrainingDetail.endDate)
              }}</span></v-col
            ></v-row
          >
          <v-row v-if="dataTrainingDetail.description">
            <v-col cols="4" sm="2" class="black--text"
              ><span>รายละเอียด:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.description }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>ประเทศ:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.countryNameTha }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>คีย์เวิร์ด:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.trainKeyword }}</span></v-col
            ></v-row
          >
          <v-row v-if="dataTrainingDetail.certificateName">
            <v-col cols="4" sm="2" class="black--text"
              ><span>ประกาศนียบัตร:</span></v-col
            ><v-col cols="8" sm="10"
              ><span>{{ dataTrainingDetail.certificateName }}</span></v-col
            ></v-row
          >
          <v-row>
            <v-col cols="4" sm="2" class="black--text"
              ><span>ระยะเวลา:</span></v-col
            ><v-col cols="8" sm="10"
              ><span class="mr-1">{{ dataTrainingDetail.workHour }}</span
              ><span>{{ dataTrainingDetail.hourTypeName }}</span></v-col
            ></v-row
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-4 mt-n8">
            <v-btn
              class="white--text mr-2"
              color="grey "
              outlined
              @click="dialogOnDetail = false"
              >ปิด
            </v-btn>
            <!-- <v-btn class="white--text " color=" success" @click="onSaveConDel()"
              >ยืนยัน
            </v-btn> -->
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditMenu" max-width="900px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text">แก้ไขข้อมูล</v-card-title>
        <v-form ref="formDialogEdit" v-model="isFormValidDialogEdit">
          <v-card-text>
            <v-divider class="mb-4"></v-divider>
            <v-row justify="center">
              <v-col cols="12" sm="5">
                <v-menu
                  v-model="startDatePickerDialogEdit"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="startDateTextDialogEdit"
                      label="วันที่เริ่มต้น"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="startDatePickerDialogEdit = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="startDateDialogEdit"
                    locale="th"
                    @input="startDatePickerDialogEdit = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="5">
                <v-menu
                  v-model="endDatePickerDialogEdit"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endDateTextDialogEdit"
                      label="วันที่สิ้นสุด"
                      append-icon="mdi-calendar"
                      hide-details
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      @click:append="endDatePickerDialogEdit = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="endDateDialogEdit"
                    locale="th"
                    :min="startDateDialogEdit"
                    @input="endDatePickerDialogEdit = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.projectName"
                  outlined
                  name="input-7-4"
                  label="ชื่อหัวข้ออบรม"
                  dense
                  hide-details="auto"
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.instituteName"
                  outlined
                  name="input-7-4"
                  label="สถานที่อบรม"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.instituteAddress"
                  outlined
                  name="input-7-4"
                  label="ที่อยู่ที่อบรม"
                  hide-details="auto"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-textarea
                  v-model="form.description"
                  outlined
                  name="input-7-4"
                  label="รายละเอียด"
                  hide-details="auto"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-autocomplete
                  v-model="form.countryID"
                  :items="countrysDataList"
                  item-text="countryNameTha"
                  item-value="countryID"
                  hide-details="auto"
                  label="ประเทศ"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row justify="center">
              <!-- <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.trainKeyword"
                  outlined
                  name="input-7-4"
                  label="คีย์เวิร์ด"
                  hide-details="auto"
                  dense
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="10">
                <v-combobox
                  v-model="trainKeywordSelectEdit"
                  :items="trainKeywordSelectItemsEdit"
                  :search-input.sync="trainKeywordTypEdit"
                  hide-selected
                  clearable
                  label="คีย์เวิร์ด"
                  multiple
                  persistent-hint
                  small-chips
                  outlined
                  dense
                  hide-details="auto"
                  deletable-chips
                  :rules="[rules.inputblank]"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-chip
                            v-if="trainKeywordTypEdit"
                            @click="addTrainKeywordEdit"
                            color="black"
                            label
                            outlined
                            >{{ trainKeywordTypEdit }}
                            <v-icon small class="ml-1" @click="closechip">
                              mdi-close-circle
                            </v-icon>
                          </v-chip>

                          <span class="grey--text">
                            กด Enter หรือ คลิ๊ก เพื่อเพิ่ม</span
                          >
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
            <!-- <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.capitalReserveName"
                  outlined
                  name="input-7-4"
                  label="ชื่อทุน"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-radio-group v-model="rCer" dense hide-details="auto" row>
                  <v-radio label="ไม่มีประกาศนียบัตร" value="2"></v-radio>
                  <v-radio label="มีประกาศนียบัตร" value="1"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row justify="center" v-if="rCer === '1'">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.certificateName"
                  outlined
                  name="input-7-4"
                  label="ชื่อประกาศนียบัตร"
                  hide-details="auto"
                  dense
                  :rules="[rules.empty]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="form.workHour"
                  outlined
                  name="input-7-4"
                  label="จำนวนชั่วโมงทำงาน"
                  hide-details="auto"
                  dense
                  type="number"
                  :rules="[rules.onlyDigit]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" class="mt-n9">
              <v-col cols="12" sm="10">
                <v-radio-group
                  v-model="form.hourType"
                  dense
                  hide-details="auto"
                  row
                >
                  <v-radio label="ชั่วโมงจริง" value="1"></v-radio>
                  <v-radio label="ชั่วโมง/สัปดาห์" value="2"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-n5">
            <v-col cols="12" sm="11">
              <v-btn
                color="primary  "
                class="float-right"
                @click="dialogEditMenuCon()"
                >บันทึก</v-btn
              >
              <v-btn
                class="white--text mr-2 float-right "
                color="grey lighten-1"
                outlined
                @click="dialogEditMenu = false"
                >ปิด
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogOnSaveEdit" max-width="500px">
      <v-card class="py-2">
        <v-card-title class="headline Black--text"
          >ยืนยันบันทึกการแก้ไข</v-card-title
        >
        <v-card-text>
          <v-divider class="mb-4"></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="mr-4 mt-n8">
            <v-btn
              class="white--text mr-2"
              color="error "
              outlined
              @click="dialogOnSaveEdit = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              class="white--text "
              color=" success"
              @click="onSaveConEdit()"
              >ยืนยัน
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadtable" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กรุณารอซักครู่...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import HistoryTable from "@/components/history/HistoryDevelopTable.vue";
export default {
  components: {
    HistoryTable,
  },
  data() {
    return {
      loading: true,
      addressList: [],
      title: "รายการดูงาน/ฝึกอบรม",
      dialogOnSave: false,
      loadtable: false,
      dialogAddMenu: false,
      programcatelogsList: [],
      form: {
        employeeId: "",
        trainingNumber: 0,
        projectName: "",
        instituteName: "",
        instituteAddress: "",
        countryID: "THA",
        trainingActionTypeId: 3,
        beginDate: "",
        endDate: "",
        capitalReserveName: "",
        certificateName: "",
        description: "",
        workHour: 5,
        hourType: "1",
        trainKeyword: "",
      },
      formDefault: {
        employeeId: "",
        trainingNumber: 0,
        projectName: "",
        instituteName: "",
        instituteAddress: "",
        countryID: "THA",
        trainingActionTypeId: 3,
        beginDate: "",
        endDate: "",
        capitalReserveName: "",
        certificateName: "",
        description: "",
        workHour: 0,
        hourType: "1",
        trainKeyword: "",
      },
      rCer: "2",
      startDate: "",
      endDate: "",
      startDateDialog: "",
      endDateDialog: "",
      leaveList: [],
      trainningactiontypesList: [],
      countrysDataList: [],
      isFormValidDialogAdd: false,
      isFormValidDialog: false,
      dialogOnDel: false,
      payloadDel: {},
      dialogEditMenu: false,
      dialogOnDetail: false,
      dataTrainingDetail: {},
      dialogOnSaveEdit: false,
      startDateDialogEdit: "",
      endDateDialogEdit: "",
      isFormValidDialogEdit: false,

      trainKeywordSelect: [],
      trainKeywordSelectItems: [],
      trainKeywordTyp: "",

      trainKeywordTypEdit: "",
      trainKeywordSelectEdit: [],
      startDatePickerDialog: false,
      endDatePickerDialog: false,
      startDatePicker: false,
      endDatePicker: false,
      startDatePickerDialogEdit: false,
      endDatePickerDialogEdit: false,
      loaddata: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "ชื่อหัวข้ออบรม",
          value: "projectName",
          class: "grey lighten-3 text-body-1 black--text",
          width: "40%",
          sortable: false,
        },
        {
          text: "วันที่เริ่ม",
          value: "beginDate",
          class: "grey lighten-3 text-body-1 black--text",
          width: "20%",
        },
        {
          text: "วันที่สิ้นสุด",
          value: "endDate",
          class: "grey lighten-3 text-body-1 black--text",
          width: "20%",
        },
        // {
        //   text: 'สถานะการอบรม',
        //   value: 'trainingAtionTypeName',
        //   class: 'grey lighten-3 text-body-2 black--text'
        // },
        {
          text: "จัดการ",
          value: "actionEmptraining",
          class: "grey lighten-3 text-body-1 black--text",
          align: "center",
          width: "20%",
          sortable: false,
        },
      ];
    },
    // trainKeywordSelect() {
    //   const typKeyWord = [{ trainKey: this.trainKeywordTyp }]
    //   return typKeyWord
    // },
    startDateText() {
      return this.$dateFormatByLang(this.startDate);
    },

    endDateText() {
      return this.$dateFormatByLang(this.endDate);
    },
    startDateTextDialog() {
      return this.$dateFormatByLang(this.startDateDialog);
    },
    endDateTextDialog() {
      return this.$dateFormatByLang(this.endDateDialog);
    },
    startDateTextDialogEdit() {
      return this.$dateFormatByLang(this.startDateDialogEdit);
    },
    endDateTextDialogEdit() {
      return this.$dateFormatByLang(this.endDateDialogEdit);
    },
    rules() {
      return {
        empty: (v) => !!v || "กรุณากรอกรายละเอียด",
        required: (v) => !!v || "ห้ามเว้นว่าง",
        onlyDigit: (v) => /^-{0,1}\d*\.{0,1}\d+$/.test(v) || "ใส่ได้แค่ตัวเลข",
        blank: (v) => (v && !!v.trim()) || "ไม่สามารถเว้นว่างได้",
        inputblank: (v) =>
          (v && v.length > 2) || "กรุณากรอกมากกว่า 2 คีย์เวิร์ด",
      };
    },
  },
  mounted() {
    this.setdate();
  },
  watch: {
    startDate() {
      if (this.startDate >= this.endDate) {
        this.endDate = this.$dateFormat(this.startDate);
      }
    },
    startDateDialog() {
      if (this.startDateDialog >= this.endDateDialog) {
        this.endDateDialog = this.$dateFormat(this.startDateDialog);
      }
    },
    startDateDialogEdit() {
      if (this.startDateDialogEdit >= this.endDateDialogEdit) {
        this.endDateDialogEdit = this.$dateFormat(this.startDateDialogEdit);
      }
    },
  },
  methods: {
    async setdate() {
      this.loaddata = true;
      const now = new Date();
      const nowMonth = now.getMonth() + 1;
      const nowYear = now.getFullYear();
      let startYear = "";
      let endYear = "";
      if (nowMonth <= 9) {
        startYear = nowYear - 1;
        endYear = nowYear;
      } else {
        startYear = nowYear;
        endYear = nowYear + 1;
      }
      this.startDate = startYear + "-10-01";
      this.endDate = endYear + "-09-30";
      this.startDateDialog = now.toISOString().split("T")[0];
      this.endDateDialog = now.toISOString().split("T")[0];
      //Refer
      this.countrysDataList = await this.apiGetCountry();

      await this.onSearch(this.startDate, this.endDate);
      this.loaddata = false;
      // console.log(this.countrysDataList)
    },

    addTrainKeyword() {
      const someResult = this.trainKeywordSelect.every((publicKeyword) => {
        return publicKeyword !== this.trainKeywordTyp;
      });

      if (someResult) {
        this.trainKeywordSelect.push(this.trainKeywordTyp);
      }
      this.trainKeywordTyp = "";
    },
    addTrainKeywordEdit() {
      const someResult = this.trainKeywordSelectEdit.every((publicKeyword) => {
        return publicKeyword !== this.trainKeywordTypEdit;
      });

      if (someResult) {
        this.trainKeywordSelectEdit.push(this.trainKeywordTypEdit);
      }

      this.trainKeywordTypEdit = "";
    },
    closechip() {
      this.trainKeywordTyp = "";
    },
    async onSearch(start, end) {
      this.leaveList = (await this.apiGetHistoryAddress(start, end)) || [];
      this.loading = false;
    },
    async apiGetHistoryAddress(start, end) {
      try {
        const payload = {
          guid: this.$guid,
          startDate: start,
          endDate: end,
        };
        // console.log('test ' + payload.guid)
        // console.log('date1 ' + payload.startDate)
        // console.log('date2 ' + payload.endDate)
        const res = await this.$store.dispatch("history/getTraining", payload);
        //console.log('res ' + JSON.stringify(res.data.data))
        return res.data?.data?.trainingList || [];
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async btnSearchAccessroles() {
      this.dialogAddMenu = true;
      this.trainningactiontypesList = await this.apiGetTrainningactiontypes();
      //this.countrysDataList = await this.apiGetCountry()

      this.form = Object.assign({}, this.formDefault);
      this.$refs.formDialogAdd.resetValidation();
      this.trainKeywordSelect = [];
      // console.log('date1 ' + this.trainningactiontypesList)
      // console.log('date2 ' + this.countrysDataList)
    },
    async apiGetTrainningactiontypes() {
      try {
        const payload = {
          dataVal: "train",
        };

        const res = await this.$store.dispatch(
          "history/getTrainningactiontypes",
          payload
        );
        //console.log('date1 ' + JSON.stringify(res.data))
        return res.data?.data || [];
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async apiGetCountry() {
      try {
        const res = await this.$store.dispatch("history/getCountry");
        //console.log('date2 ' + JSON.stringify(res.data.data))
        return res.data?.data || [];
      } catch (e) {
        console.log(e.response || e);
      }
    },
    dialogAddMenuCon() {
      if (!this.isFormValidDialogAdd) {
        this.$refs.formDialogAdd.validate(); //คำสั่งให้มีสีแดงเมื่อ error
        this.$nextTick(() => {
          const el = document.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        });
      } else {
        this.dialogOnSave = true;
      }
    },
    async onSaveCon() {
      this.form.employeeId = this.$guid;
      this.form.beginDate = this.startDateDialog;
      this.form.endDate = this.endDateDialog;

      this.form.trainKeyword = this.trainKeywordSelect.toString();
      if (this.rCer === "2") {
        this.form.certificateName = "";
      }
      //console.log(this.form)
      await this.apiPostTraining();
      await this.onSearch(this.startDate, this.endDate);
    },
    async apiPostTraining() {
      this.dialogOnSave = false;
      this.loadtable = true;
      try {
        this.form.hourType = parseInt(this.form.hourType);
        const payload = this.form;

        const res = await this.$store.dispatch("history/postTraining", payload);
        this.dialogAddMenu = false;
        this.loadtable = false;

        return res.data?.data || [];
        //console.log('date1 ' + JSON.stringify(res.data))
      } catch (e) {
        console.log(e.response || e);
      }
    },
    onSaveConDelDialog(trainingNumber) {
      this.payloadDel = {
        empId: this.$guid,
        trainNum: trainingNumber,
      };
      this.dialogOnDel = true;
    },
    async onSaveConDel() {
      //console.log(this.form)
      await this.apiDelTraining();
      //await this.onSearch(0, 0);
      await this.onSearch(this.startDate, this.endDate);
    },
    async apiDelTraining() {
      this.dialogOnDel = false;
      this.loadtable = true;
      try {
        const payload = this.payloadDel;

        const res = await this.$store.dispatch("history/delTraining", payload);

        this.loadtable = false;

        return res.data?.data || [];
        //console.log('date1 ' + JSON.stringify(res.data))
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async detailDialog(trainingNumber) {
      this.dialogOnDetail = true;

      this.dataTrainingDetail = await this.apiGetTrainingDetail(trainingNumber);
      //console.log(this.dataTrainingDetail)
    },
    async apiGetTrainingDetail(trainingNumber) {
      try {
        const payload = {
          empId: this.$guid,
          trainNum: trainingNumber,
        };

        const res = await this.$store.dispatch(
          "history/getTrainingDataByNumber",
          payload
        );

        return res.data?.data || [];
        //console.log('date1 ' + JSON.stringify(res.data))
      } catch (e) {
        console.log(e.response || e);
      }
    },
    async btnEditDetail(trainingNumber) {
      this.dialogEditMenu = true;

      this.dataTrainingDetail = await this.apiGetTrainingDetail(trainingNumber);
      this.$refs.formDialogEdit.resetValidation();
      //Set Data
      this.form = this.dataTrainingDetail;
      //Data edit
      this.startDateDialogEdit = this.form.beginDate.toString().split("T")[0];
      this.endDateDialogEdit = this.form.endDate.toString().split("T")[0];

      //console.log('asd ' + JSON.stringify(this.form.countryID))
      if (this.form.certificateName === "") {
        this.rCer = "2";
      }
      if (this.form.hourType) {
        this.form.hourType = this.form.hourType.toString();
      } else {
        this.form.hourType = "1";
      }

      //console.log('sdaas0 ' + this.form.trainKeyword)
      if (!this.form.trainKeyword) {
        this.trainKeywordSelectEdit = [];
      } else {
        if (this.form.trainKeyword.split(",").length === 1) {
          // console.log('sdaas1 ')
          this.trainKeywordSelectEdit = [];
          this.trainKeywordSelectEdit.push(this.form.trainKeyword);
        } else {
          // console.log('sdaas2 ')
          this.trainKeywordSelectEdit = this.form.trainKeyword.split(",");
        }
      }

      // console.log('sdaas2 ' + this.arrTrainKeyword.length)
      // console.log('sdaas3 ' + JSON.stringify(this.trainKeywordSelectEdit))
    },
    dialogEditMenuCon() {
      if (!this.isFormValidDialogEdit) {
        this.$refs.formDialogEdit.validate(); //คำสั่งให้มีสีแดงเมื่อ error
        this.$nextTick(() => {
          const el = document.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        });
      } else {
        this.dialogOnSaveEdit = true;
      }
    },

    async onSaveConEdit() {
      this.dialogOnSaveEdit = false;
      this.loadtable = true;
      this.form.hourType = parseInt(this.form.hourType);
      this.form.trainingActionTypeId = "3";
      this.form.beginDate = this.startDateDialogEdit.toString().split("T")[0];
      this.form.endDate = this.endDateDialogEdit.toString().split("T")[0];
      if (this.rCer === "2") {
        this.form.certificateName = "";
      }

      this.form.trainKeyword = this.trainKeywordSelectEdit.toString();

      //console.log(this.form)
      await this.apiPutTrainingDetail();
      //await this.onSearch(0, 0);
      await this.onSearch(this.startDate, this.endDate);
      this.loadtable = false;
      this.dialogEditMenu = false;
    },
    async apiPutTrainingDetail() {
      try {
        const payload = this.form;

        const res = await this.$store.dispatch(
          "history/putTrainingData",
          payload
        );

        return res.data?.data || [];
        //console.log('date1 ' + JSON.stringify(res.data))
      } catch (e) {
        console.log(e.response || e);
      }
    },
  },
};
</script>
